import React from 'react'
import CustomTag from 'components/CustomTag'

const RoleStatus = ({ status }) => {
  let colorType
  let tagMessage
  if (status == '0') {
    colorType = 'grey'
    tagMessage = 'Draft'
  } else if (status == '1') {
    colorType = 'green'
    tagMessage = 'Active'
  } else if (status == -1) {
    colorType = 'red'
    tagMessage = 'Closed'
  }
  return <CustomTag colorType={colorType} message={tagMessage} />
}

export default RoleStatus
